import { createFileRoute } from "@tanstack/react-router"

import { Stack } from "@chakra-ui/react"
import { useEffect } from "react"
import Checkout from "../components/Checkout"
import useFrame from "../hooks/useFrame"

const CheckoutRoute: React.FC = () => {
  const { containerRef, sendHeight } = useFrame()
  useEffect(() => {
    sendHeight()
  }, [sendHeight])

  return (
    <>
      <Stack ref={containerRef}>
        <Checkout />
      </Stack>
    </>
  )
}

export const Route = createFileRoute("/checkout")({
  component: CheckoutRoute,
})
